import {computed} from 'vue'

export default function useCookies() {

    const isLead = computed(() => {
        let lead = Cookies.get(window.COOKIE_NAME_LEAD)

        return lead !== undefined;
    })

    return {
        isLead
    }
}
